import React, { useState } from 'react';
import Select from 'react-select';

function SelectProduct({ onSelectChange }) {
  const [channel, setChannel] = useState({ value: 'ELEHEAR Delight', label: 'ELEHEAR Delight' });

  const options = [
    { value: 'ELEHEAR Delight', label: 'ELEHEAR Delight' },
    { value: 'ELEHEAR Beyond Pro', label: 'ELEHEAR Beyond Pro' },
    { value: 'ELEHEAR Beyond', label: 'ELEHEAR Beyond' }
  ];

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      height: '100%',
      border: 'none',
    }),
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      height: '100%',
      border: 'none',
      border: state.isFocused ? '2px solid rgb(230,153,5)' : 'none',
      boxShadow: 'none',
      borderRadius: '16px',
      paddingRight: '30px', // 控制下拉箭头的位置
      backgroundColor: 'rgba(244, 244, 244, 1)',
      textAlign: 'left', // 设置选择框中的文字居左
      paddingLeft: '10px',  // 控制左侧内边距
      paddingRight: '10px', // 减小右侧内边距，让下拉按钮占用更少空间
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '16px',
      color: '#333',
      maxWidth: 'calc(100% - 30px)', // 设置最大宽度，避免文本被压缩
      whiteSpace: 'nowrap', // 禁止换行
      overflow: 'hidden', // 隐藏溢出内容
      textOverflow: 'ellipsis', // 溢出时显示省略号
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '16px',
      color: '#999',
      maxWidth: 'calc(100% - 30px)', // 设置最大宽度，避免文本被压缩
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 5px', // 减少下拉箭头的左右内边距
      width: '40px', // 保证下拉按钮不会占用固定的过多空间
      height: 'auto', // 保证高度自适应
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '16px',
      color: '#333',
      backgroundColor: '#fff',
      textAlign: 'left', // 设置选择框中的文字居左
      paddingLeft: '20px',
      ':hover': {
        backgroundColor: '#f0f0f0',
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '5px',
      overflow: 'hidden',
    }),
  };

  const handleChange = (selectedOption) => {
    setChannel(selectedOption); // 更新本地状态
    onSelectChange(selectedOption.value); // 调用回调，将选中值传递给父组件
  };

  return (
    <Select
      value={channel}
      onChange={handleChange}
      options={options}
      styles={customStyles}
    />
  );
}

export default SelectProduct;
